<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :search.sync="search"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :autoComplete="autoComplete"
            :multiple="multiple"
            :showAdd="showAdd"
            :disabled="disabled"
            :autofocus="autofocus"
            :dense="dense"
        />
        <sys-register-teacher @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectTeacher',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false,
        search: ''
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        if(this.data && typeof this.data === 'object' && this.data.id){
            this.items.push(this.data);
            this.selected = this.model;
        } else {
            this.getItems();
        }
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        dense: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        data: {
            required: false
        },
        selectedObject: {
            
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        companyIds: {
            type: Array,
            default: () => []
        }
        
    },
    watch: {
        
        data(val) {
            
            this.items = [];
            
            if(val){
                this.items.push(val);
                this.selected = this.model;
            }
            
        },

        selected(val){
            
            this.$emit('update:model', val);

            if(val && this.selectedObject){
                
                let teacher = this.items.find(i => i.id == val);
                if(teacher){
                    this.$emit('update:selectedObject', teacher);
                }
            }

        },
        
        model(val){
            this.selected = val;
        },
        search(newSearch, oldSearch) {

            this.getItems()
            
        },

        companyIds(newVal, oldVal) {
            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                this.selected = null
                this.$emit('update:model', null)
                this.getItems()
            }
        },
    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeachers']),        
        
        async getItems() {

            this.loading = true
            let payload = {
                column_order: 'name',
                direction: 'asc',
                search: this.search || '',
                per_page: this.multiple ? 500 : 50,
                find_columns: {
                    active: 1,
                }
            }

            if(this.selectedObject){
                payload.with = 'campuses';
            }

            if(this.companyIds && this.companyIds.length > 0){
                payload.filter_relations = [
                    {
                        name: 'contracts',
                        key: 'company_id',
                        clause: 'whereIn',
                        value: this.companyIds.join(',')
                    }
                ];
            }

            await this.ActionFindTeachers(payload)
                    .then((res) => {
                        const data = res.data;
                        this.items = Array.isArray(data) ? data : (data?.data || []);
                        this.selected = this.model;
                    })
                    .catch(() => {
                        this.items = [];
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>